import { Controller } from '@hotwired/stimulus';
import { dayjs } from '../../../components/dayjs-localized';
import dayjsCustomParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(dayjsCustomParseFormat);

export default class extends Controller {
  static targets = [
    'startDatePicker',
    'endDatePicker',
  ];

  connect() {
    this.errorContainer = this.element.querySelector('#error-container');
  }

  handleSubmit(event) {
    event.preventDefault();

    this.handleError();

    if (this.canSubmit()) {
      this.element.requestSubmit();
    }
  }

  handleError() {
    if (this.missingBothDates()) {
      this.showError('Il faut remplir les deux dates');
    } else if (this.hasIncoherentDates()) {
      this.showError('La date de début doit précéder la date de fin.');
    } else if (this.isInFuture()) {
      this.showError('La date de début et la date de fin doivent être dans le passé.');
    } else {
      this.hideError();
    }
  }

  canSubmit() {
    return !this.hasIncoherentDates() && !this.missingBothDates() && !this.isInFuture();
  }

  hasIncoherentDates() {
    const startDate = dayjs(this.startDatePickerTarget.value, 'DD/MM/YYYY');
    const endDate = dayjs(this.endDatePickerTarget.value, 'DD/MM/YYYY');

    return startDate > endDate;
  }

  missingBothDates() {
    return this.startDatePickerTarget.value === '' || this.endDatePickerTarget.value === '';
  }

  isInFuture() {
    const startDate = dayjs(this.startDatePickerTarget.value, 'DD/MM/YYYY');
    const endDate = dayjs(this.endDatePickerTarget.value, 'DD/MM/YYYY');
    const today = dayjs();

    return startDate.isAfter(today) || endDate.isAfter(today);
  }

  showError(message) {
    this.errorContainer.classList.remove('d-none');
    this.errorContainer.textContent = message;
  }

  hideError() {
    this.errorContainer.classList.add('d-none');
  }
}
